import axios from 'axios';
import qs from 'query-string';
const instance = axios.create();

const find = async ({ newToken, query }) => {
  const { data, headers } = await instance.get(
    `${process.env.REACT_APP_API_URL}/claims?${qs.stringify(query)}`,
    {
      headers: {
        Authorization: newToken,
      },
    }
  );

  return {
    data: data.claims,
    total: headers['x-total-count'],
  };
};

const claimsAPIs = {
  find,
};

export default claimsAPIs;
